export const colours = ['#D12038', '#AA3BDB', '#3540C4', '#30BEDB', '#3DC26F']
